export enum BusinessSector {		
	Aerospace = 10,
	Automotive = 20,
	Defence = 30,
	Medical = 40,
	OilAndGas = 50,
	Rail = 60,
	Renewables = 70,
	WhiteGoods = 80,
	YellowGoods = 90,
	Others = 999,
}